/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { BaseAddressComponentMapper } from './base-address-component.mapper';
import { AddressDTO } from "@well/address-management-domain-model";

export class PostalCodeAddressComponentMapper extends BaseAddressComponentMapper {

  mapAddress(address: AddressDTO) {
    address.postalCode = this.addressComponent?.short_name;
  }
}
